import { apiMutate } from './csrf-fetch';

export const EVENTO_SESSAO_EXPIRADA = 'pieltec:sessao-expirada';

export function deveRedirecionarAoExpirarSessao(pathname: string, temCredencialDispositivo: boolean): boolean {
  if (pathname.startsWith('/coletor') && temCredencialDispositivo) {
    return false;
  }
  return true;
}

export function notificarSessaoExpirada(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENTO_SESSAO_EXPIRADA));
  }
}

/** Timer só envia se houve interação: uma aba aberta ou polling não sustenta login. */
export function iniciarAtividadeSessao(documento: Document, aoExpirar: () => void): () => void {
  let atividadePendente = false;
  let emCurso = false;
  let encerrado = false;
  const registrar = (event: Event) => {
    if (event.isTrusted && documento.visibilityState === 'visible') atividadePendente = true;
  };
  const eventos = ['pointerdown', 'pointermove', 'keydown', 'input', 'wheel', 'touchstart'];
  for (const evento of eventos) documento.addEventListener(evento, registrar, { passive: true });
  const timer = setInterval(() => {
    if (!atividadePendente || emCurso || documento.visibilityState !== 'visible') return;
    atividadePendente = false;
    emCurso = true;
    void apiMutate('/api/v1/auth/activity', {}).then((res) => {
      if (res.status === 401 && !encerrado) aoExpirar();
    }).catch(() => {
      // Falha transitória não descarta um formulário nem simula logout.
    }).finally(() => { emCurso = false; });
  }, 30_000);
  return () => {
    encerrado = true;
    clearInterval(timer);
    for (const evento of eventos) documento.removeEventListener(evento, registrar);
  };
}
